import React ,{Component}from "react";
// import PortfolioReturn from "./section1/portfolioReturn";
import Volatility from "./section2/volatility";
// import MonthlyPerformance from '../performance/section1/monthlyPerformance';
import CalenderYearPerformance from './section1/monthlyPerformance'
import $ from 'jquery';

class Returns extends Component{
  state = {
    data: [],
    monthlyPerformance: [],
    spinner: true,
    initialWidth:0
  };

componentDidMount() {
    let res = this.props.getPerfHistMetrics;  
    if (res) {
      const all_values = [];
      for (let i in res) {
        let line = res[i];
        let year = parseInt(line.metric_name);

        // if (year <= 2017 && year >= 2012) {
          if (year >= 2012) {
          all_values.push({
            metric_name: year,
            portfolio: parseFloat([line.fund_return*100]),
            benchmark: parseFloat([line.bm_return*100])
          });
        }
      }
      all_values.sort(
        (a, b) => parseInt(b.metric_name) - parseInt(a.metric_name)
      );

      let LayoutWidth = $(".container-wrapper").width() - 30;
    let initialWidth = (LayoutWidth / 100) * 53;

      this.setState({
        data: res,
        monthlyPerformance: all_values,
        spinner : false,
        initialWidth:initialWidth
      });
    }
}
  render(){
    const { monthlyPerformance, spinner,initialWidth } = this.state;
  return (
    <div className="row">
      {/* <PortfolioReturn {...props} /> */}
      {/* replacing table by bar chart */}
      
         {initialWidth > 0 ? <CalenderYearPerformance data={monthlyPerformance} spinner={spinner} initialWidth={initialWidth} {...this.props}/> : null }
      {/* <Volatility {...this.props}/> */}
    </div>
  );
  }
}

export default Returns;


// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/backtest/returns/returns.jsx